<div
  class="admin-page-container"
  *ngIf="!(loading$ | async); else loadingTemplate">
  <form #notificationForm="ngForm">
    <div class="card-box main-card">
      <div class="notification-settings-container">
        <div
          *ngFor="let setting of notificationSettings$ | async; let i = index"
          class="notification-setting-card">
          <div class="card-box">
            <div class="card-title-row">
              <mat-form-field class="light-form-field card-title-input">
                <mat-label>{{ "label" | i18n | titlecase }}</mat-label>
                <input
                  matInput
                  [(ngModel)]="setting.label"
                  [name]="'label-' + i"
                  [attr.data-cy]="'label-' + i"
                  required />
              </mat-form-field>
              <button
                class="outline-pill-button icon-left text-error"
                type="button"
                (click)="removeNotificationSetting(i)"
                data-cy="remove-notification-setting">
                <mat-icon svgIcon="close"></mat-icon>
                {{ "remove" | i18n | titlecase }}
              </button>
            </div>

            <div class="card-content">
              <div class="setting-form">
                <div class="form-flex-row">
                  <mat-form-field class="light-form-field">
                    <mat-label>{{
                      "notificationType" | i18n | titlecase
                    }}</mat-label>
                    <mat-select
                      [(ngModel)]="setting.notificationType"
                      [name]="'notificationType-' + i"
                      [attr.data-cy]="'notificationType-' + i"
                      (selectionChange)="
                        onNotificationTypeChange(setting, targetInput)
                      "
                      required>
                      <mat-option value="email">{{
                        "email" | i18n | titlecase
                      }}</mat-option>
                      <mat-option value="sms">{{
                        "sms" | i18n | titlecase
                      }}</mat-option>
                    </mat-select>
                  </mat-form-field>

                  <mat-form-field class="light-form-field">
                    <mat-label>
                      {{
                        setting.notificationType === "email"
                          ? ("emailAddress" | i18n)
                          : ("phoneNumber" | i18n | titlecase)
                      }}
                    </mat-label>
                    <input
                      #targetInput
                      matInput
                      [(ngModel)]="setting.target"
                      [name]="'target-' + i"
                      [attr.data-cy]="'target-' + i"
                      [type]="
                        setting.notificationType === 'email' ? 'email' : 'tel'
                      "
                      [pattern]="
                        setting.notificationType === 'email'
                          ? '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$'
                          : '^[+]?[0-9\\s()-]*$'
                      "
                      [title]="
                        setting.notificationType === 'email'
                          ? 'Please enter a valid email address'
                          : 'Please enter a valid phone number (numbers, spaces, +, -, () allowed)'
                      "
                      (keyup)="trimPhoneTarget(setting)"
                      required />
                  </mat-form-field>
                </div>

                <div class="department-section">
                  <app-department-select
                    [isMultiSelect]="true"
                    [selectedDepartmentIds]="setting.departmentIds || []"
                    [label]="'departments' | i18n"
                    (departmentsSelectionChanged)="
                      onDepartmentsChanged($event, setting)
                    ">
                  </app-department-select>
                </div>

                <div class="weekday-schedule-section">
                  <div
                    *ngFor="let weekday of weekdays"
                    class="weekday-row">
                    <div class="weekday-toggle">
                      <mat-slide-toggle
                        [(ngModel)]="setting.weekdaySchedule[weekday].enabled"
                        [name]="'weekday-' + weekday + '-' + i"
                        color="primary">
                        <span
                          class="toggle-label"
                          [class.inactive]="
                            !setting.weekdaySchedule[weekday].enabled
                          ">
                          {{
                            ("weekdays." + weekday | i18n) || weekday
                              | titlecase
                          }}
                        </span>
                        <span
                          class="whole-day-hint"
                          *ngIf="
                            !setting.weekdaySchedule[weekday].timeRanges.length
                          ">
                          ({{ "wholeDay" | i18n | titlecase }})
                        </span>
                      </mat-slide-toggle>
                    </div>

                    <div class="time-ranges-container">
                      <div
                        *ngFor="
                          let timeRange of setting.weekdaySchedule[weekday]
                            .timeRanges;
                          let rangeIndex = index
                        "
                        class="time-range-group">
                        <div class="time-flex-inputs">
                          <mat-form-field class="light-form-field time-field">
                            <mat-label>{{
                              "timeFrom" | i18n | titlecase
                            }}</mat-label>
                            <input
                              matInput
                              type="time"
                              [(ngModel)]="timeRange.timeFrom"
                              [name]="
                                'timeFrom-' +
                                weekday +
                                '-' +
                                i +
                                '-' +
                                rangeIndex
                              "
                              [attr.data-cy]="
                                'timeFrom-' +
                                weekday +
                                '-' +
                                i +
                                '-' +
                                rangeIndex
                              "
                              [required]="
                                setting.weekdaySchedule[weekday].enabled
                              "
                              [disabled]="
                                !setting.weekdaySchedule[weekday].enabled
                              " />
                          </mat-form-field>

                          <mat-form-field class="light-form-field time-field">
                            <mat-label>{{
                              "timeTo" | i18n | titlecase
                            }}</mat-label>
                            <input
                              matInput
                              type="time"
                              [(ngModel)]="timeRange.timeTo"
                              [name]="
                                'timeTo-' + weekday + '-' + i + '-' + rangeIndex
                              "
                              [attr.data-cy]="
                                'timeTo-' + weekday + '-' + i + '-' + rangeIndex
                              "
                              [required]="
                                setting.weekdaySchedule[weekday].enabled
                              "
                              [disabled]="
                                !setting.weekdaySchedule[weekday].enabled
                              " />
                          </mat-form-field>

                          <button
                            class="remove-time-range-button"
                            type="button"
                            (click)="
                              removeTimeRange(setting, weekday, timeRange.id)
                            "
                            [attr.data-cy]="
                              'remove-time-range-' +
                              weekday +
                              '-' +
                              i +
                              '-' +
                              rangeIndex
                            ">
                            <mat-icon
                              svgIcon="close"
                              class="size-12"></mat-icon>
                          </button>
                        </div>
                      </div>

                      <div class="empty-time-ranges">
                        <button
                          class="add-first-time-range-button"
                          type="button"
                          (click)="
                            addTimeRange(setting.weekdaySchedule[weekday])
                          "
                          [attr.data-cy]="
                            'add-first-time-range-' + weekday + '-' + i
                          ">
                          <mat-icon svgIcon="plus"></mat-icon>
                          {{ "addTimeRange" | i18n }}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          *ngIf="(notificationSettings$ | async)?.length === 0"
          class="empty-state">
          <p>
            {{ "noNotificationsConfigured" | i18n | titlecase }}
          </p>
        </div>
        <div class="add-setting-section">
          <button
            class="outline-pill-button icon-left"
            type="button"
            (click)="addNotificationSetting()"
            data-cy="add-notification-setting">
            <mat-icon svgIcon="plus"></mat-icon>
            <span class="mat-fab__label">{{
              "addNotification" | i18n | titlecase
            }}</span>
          </button>
        </div>
      </div>
    </div>
  </form>

  <div class="floating-actions-bar">
    <button
      class="secondary-pill-button icon-left big-fab"
      (click)="historyBack()"
      type="button"
      data-cy="cancel-button">
      <mat-icon svgIcon="arrow-left"></mat-icon>
      <span class="mat-fab__label">{{ "cancel" | i18n | titlecase }}</span>
    </button>
    <button
      class="primary-pill-button icon-left big-fab"
      (click)="saveNotificationSettings()"
      type="button"
      data-cy="save-button">
      <mat-icon svgIcon="save"></mat-icon>
      <span class="mat-fab__label">{{ "save" | i18n | titlecase }}</span>
    </button>
  </div>
</div>
<ng-template #loadingTemplate>
  <mat-spinner diameter="34"></mat-spinner
></ng-template>
